import React from 'react';
import { motion } from 'framer-motion';

const TourCTASection = () => {
  return (
    <section className="py-24 bg-padua-ivory relative border-y border-padua-gold/10">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-5xl font-serif text-padua-charcoal mb-6">
            Come See Padua in Person
          </h2>
          <p className="text-lg md:text-xl text-padua-charcoal/70 mb-10 leading-relaxed text-balance">
            Photos help, but the venue is best experienced in person. Walk through the ceremony spaces and scenic photo locations with our team.
          </p>
          
          <a
            href="https://tour.paduaweddings.com"
            className="inline-block bg-padua-olive text-padua-ivory hover:bg-padua-charcoal font-medium px-12 py-4 rounded-sm tracking-widest transition-all duration-300 uppercase text-sm border border-padua-gold/20 shadow-xl"
          >
            Book Your Tour
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default TourCTASection;